<template>
  <div class="cmp-payment-fail container-payment-fail d-flex flex-row">
    <aside class="sidebar d-flex justify-content-center align-items-center">
      <div id="logo">
        <img
          style="width: 85%"
          :src="
            'https://detailss3web.s3.amazonaws.com/images/logo/' +
            clientId +
            'logo'
          "
          alt="logo"
          srcset=""
        />
      </div>
    </aside>
    <section
      class="payment-content d-flex justify-content-center align-items-center"
    >
      <div id="payment_types" class="container-payment-fail">
        <div class="mb-30">
          <h2 class="heading">Hello</h2>
          <p class="intro-text">
            <h2>{{ $t("unfortunately_payment_authorization_failed") }}</h2><br/>
            <span style="font-size:11px;" class="block"> {{ $t("this_means_card_declined") }}</span>
          </p>
        </div>
        <div class="thumb-box mb-10">
          <span  class="intro-text bold" >{{
            $t("invoice_item_costs")
          }}</span>
          <div class="invoice-items">
            <p
              v-for="(invoiceLine, index) of invoiceLines"
              :key="invoiceLine.description + index"
              :style="{
                color: index == 0 ? `var(--c-error)` : 'inherit',
                margin: index == 0 ? `12px 8px` : `4px 8px`,
              }"
            >
              {{ invoiceLine.description }}
              <b v-if="!isNaN(invoiceLine.amount)"
                >&euro;{{ $dft.curr(invoiceLine.amount) }}</b
              >
            </p>
            <div style="height: 16px"></div>
          </div>
        </div>
        <div
          v-show="errMessage"
          style="padding: 15px 20px"
          id="resultPaymentFail"
        >
          {{ errMessage }}
        </div>
        <div
          v-if="mday < 15 && paid_in_full != 'BLOCK'"
          class="thumb-box mb-10"
        >
          <p class="intro-text">
            You can
            <span class="bold">{{ $t("ignore_message_working") }}. </span>
          </p>
          <p class="intro-text">
            {{ $t("note_option_will_last_text") }}
          </p>
          <a @click="onContinue()" class="btn-link">{{
            $t("continue_working_for_now")
          }}</a>
        </div>

        <div class="thumb-box mb-10">
          <p class="intro-text" v-html="$t('wish_to_update_payment_info')">
        
          </p>
          <div class="d-flex">
            <a
              href="javascript:void()"
              @click="displayCard()"
              class="btn-link"
              >{{ $t("new_credit_card") }}</a
            >
            <span  v-if="paid_in_full != 'BLOCK' && paid_in_full != 'FAIL' && !SEPA_block" class="or d-flex align-items-center">{{ $t('word_or') }}</span>
            <a
             v-if="paid_in_full != 'BLOCK' && paid_in_full != 'FAIL' && !SEPA_block"
              @click="displaySepa()"
              href="javascript:void()"
              class="btn-link"
              >{{ $t("new_sepa_account") }}</a
            >
          </div>
          <div
            id="card_box"
            class="payment_type_box"
            style="padding: 20px"
            v-if="showCard"
          >
            <div id="card" class="payment"></div>
          </div>
          <div
            v-if="showSepadirectdebit"
            id="sepadirectdebit_box"
            class="payment_type_box"
            style="padding: 20px"
          >
            <div id="sepadirectdebit" class="payment"></div>
          </div>
        </div>

        <div class="thumb-box mb-10">
          <p class="intro-text" v-html="$t('try_payment_again_note')">
          
          </p>
          <a @click="payBill()" class="btn-link">{{
            $t("try_payment_again")
          }}</a>
        </div>

        <p class="mt-30 mb-0">
          {{$t('have_any_questions1')}}
          <a @click="emailLink" class="link-text"> {{$t('have_any_questions2')}}</a>.
          <span class="block">{{ $t('happy_to_help') }}</span>
        </p>
      </div>
    </section>
  </div>
</template>

<script>
import { clientName } from "../../../services/http/http-client";
import "@adyen/adyen-web/dist/adyen.css";
import { mapGetters } from "vuex";
import { AccountService } from "../../../services/account.service";
import { NotificationService } from "../../../dt-plugins/notification/notification.service";
import { sendMailHref } from "../../../utility";
import * as ActionTypes from "../../../store/app/account/types";
export default {
  data: function () {
    return {
      type: "card",
      errMessage: "",
      payment_method: "",
      showSepadirectdebit: false,
      showCard: false,
    };
  },
  computed: {
    ...mapGetters(["account", "routeBeforeBlock"]),
    invoiceLines: function () {
      console.log("account", this.account);
      return this.account?.invoice_lines || [];
    },
    adyen_server_type: function () {
      return this.account?.adyen_server_type || "";
    },
    mday: function () {
      return this.account?.mday || "";
    },

    amount: function () {
      return this.account?.amount * 100 || 0;
    },
    client_key: function () {
      return this.account?.client_key || "";
    },
    paid_in_full: function () {
      return this.account?.client?.paid_in_full || "";
    },
    SEPA_block: function () {
      return this.account?.client?.SEPA_block || "";
    },

    clientId() {
      return clientName;
    },
  },
  async mounted() {},
  methods: {
    emailLink: function () {
      const body = "";
      const subject = "";
      const mails = ["support@berlin3.com"];
      sendMailHref({ subject, body, mails });
    },

    onContinue: async function () {
      
      this.$store.commit(ActionTypes.SET_ACCOUNT_INFO, {
        ...this.account,
        paywall_block:false
      });
      this.$router.push({
        path: '/main/booking/booking_list',
      });
    },
    payBill: async function () {
      const response = await AccountService.payBill();
      this.handlePaymentReponse(response);
    },
    hideAllPaymentTypeBoxes() {
      this.showCard = false;
      this.showSepadirectdebit = false;
    },
    displaySepa() {
      this.hideAllPaymentTypeBoxes();
      this.showSepadirectdebit = true;
      this.initCheckout("sepadirectdebit");
    },
    displayCard() {
      this.hideAllPaymentTypeBoxes();
      this.showCard = true;
      this.initCheckout("card");
    },
    paymentSuccesful: function () {
      this.$router.push({
        path: this.routeBeforeBlock,
      });
      NotificationService.showNotification({
        text: "Payment Succesful",
        timeout: 3000,
      });
    },
    paymentFailed: function ({ paymentTarget = "credit/debit card" } = {}) {
      NotificationService.showNotification({
        text: `Payment authorization to your ${paymentTarget} has failed`,
        timeout: 3000,
        type: "error",
      });
    },
    handlePaymentReponse: function (
      response,
      { paymentTarget = "credit/debit card" } = {}
    ) {
      console.log(response, response.status);
      if (response?.data?.error) {
        this.paymentFailed({ paymentTarget });
      } else {
        this.paymentSuccesful();
      }
    },

    async initCheckout(type = "card") {
      try {
        this.payment_method = type;
        const configuration = {
          paymentMethodsResponse: this.filterUnimplemented({
            paymentMethods: ["scheme", "sepadirectdebit"],
          }),
          clientKey: this.client_key,
          locale: "en_US",
          environment: this.adyen_server_type,
          showPayButton: true,
          paymentMethodsConfiguration: {
            ideal: {
              showImage: true,
            },
            card: {
              hasHolderName: true,
              holderNameRequired: true,
              name: "Credit or debit card",
              amount: {
                value: this.amount,
                currency: "EUR",
              },
              billingAddressRequired: true,
            },
          },
          onSubmit: (state, component) => {
            if (state.isValid) {
              this.handleSubmission(state, component, "make_payment");
            }
          },
          onAdditionalDetails: (state, component) => {
            this.handleSubmission(state, component, "update_billing_info_3ds");
          },
        };
        const AdyenCheckout = (await import("@adyen/adyen-web")).default;

        AdyenCheckout(configuration).then((checkout) => {
          checkout.create(type).mount(document.getElementById(type));
        });
      } catch (error) {
        console.error(error);
      }
    },
    filterUnimplemented(pm) {
      pm.paymentMethods = pm.paymentMethods.filter((it) =>
        [
          "scheme",
          "ideal",
          "dotpay",
          "giropay",
          "sepadirectdebit",
          "directEbanking",
          "ach",
          "alipay",
        ].includes(it.type)
      );
      return pm;
    },
    async handleSubmission(state, component, action) {
      try {
        let { data } = state;
        data.action = action;
        data.section = "pay";
        data.riskData = JSON.stringify(data?.riskData || {});
        data.browserInfo = JSON.stringify(data?.browserInfo || {});
        data.paymentMethod = JSON.stringify(data?.paymentMethod || {});
        data.billingAddress = JSON.stringify(data?.billingAddress || {});
        data.amount = JSON.stringify(
          {
            value: this.amount,
            currency: "EUR",
          } || {}
        );
        data.clientID = this.clientId;
        data.payment_method = this.payment_method;
        const res = await this.callServer(data);
        this.handleServerResponse(res, component);
      } catch (error) {
        console.error(error);
      }
    },
    async callServer(params) {
      let urlSearchParams = new URLSearchParams();
      for (const k in params) {
        urlSearchParams.append(k, params[k]);
      }
      // console.log(params);
      let headers = new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      });
      let request = new Request(`billing.pl`, {
        method: "POST",
        headers: headers,
        body: urlSearchParams,
        credentials: "include",
      });

      const res = await fetch(request);

      return await res.json();
    },

    async handleServerResponse(res, component) {
      console.log(res);
      if (res.last_step_url != "") {
        window.location.replace(res.last_step_url);
      } else if (res.action) {
        component.handleAction(res.action);
      } else {
        console.log("resultCode", "resultCode");

        this._handleServerResponse(res);
      }
    },

    _handleServerResponse(res) {
      const resultContainerDiv = document.getElementById(`resultPaymentFail`);
      resultContainerDiv.classList.remove(
        "bg-success",
        "bg-warning",
        "bg-danger",
        "text-white",
        "text-dark"
      );
      switch (res.resultCode) {
        case "Authorised":
          this.errMessage = `Your payment has been successfully placed.`;
          resultContainerDiv.style = `background-color: #28a745 !important;
          color: white;padding:5px 20px;margin:10px 2px`;
          break;

        case "Pending":
        case "Received":
          this.errMessage = `Your payment has been received! Payment completion pending.`;
          resultContainerDiv.style = `background-color: #ffc107!important;
          color: white;padding:5px 20px;margin:10px 2px`;
          break;

        case "Refused":
          this.errMessage = `Your payment has been Refused! please try again.`;
          resultContainerDiv.style = `background-color: #ffc107!important;
          color: white;padding:5px 20px;margin:10px 2px`;
          break;

        case "ConnectionError":
          this.errMessage = `There was an error connecting to Adyen. status:${res.status_line}. content:${res.content}`;
          resultContainerDiv.style = `background-color: #dc3545!important;
          color: white;padding:5px 20px;margin:10px 2px`;
          break;

        case "other":
          this.errMessage = res.content;
          resultContainerDiv.style = `background-color: #dc3545!important;
         color: white;padding:5px 20px;margin:10px 2px`;
          break;

        default:
          this.errMessage = `Your payment was not successful, please try again.`;
          resultContainerDiv.style = `background-color:#dc3545!important;
          color: white;padding:5px 20px;margin:10px 2px`;
          break;
      }
      this.hideAllPaymentTypeBoxes();
    },
  },
};
</script>

<style lang="scss" scoped>
.cmp-payment-fail {
  height: 100%;
  .heading {
    font-weight: 400;
    margin-bottom: 0;
  }

  .intro-text {
    font-size: 13px;
    line-height: 18px;
    margin-bottom: 11px;

    .bold {
      font-weight: 700;
    }
  }
  .bold {
      font-weight: 700;
    }
  .block {
    display: block;
  }

  .or {
    padding: 0 10px;
    flex: 0 0 auto !important;
  }

  .mb-0 {
    margin-bottom: 0;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .mb-30 {
    margin-bottom: 30px;
  }

  .mt-30 {
    margin-top: 30px;
  }

  .display-block {
    display: block;
  }

  .thumb-box {
    background-color: #fff;
    border: 1px solid #c8c8c8;
    padding: 16px;
    border-radius: 7px;
    -webkit-box-shadow: 0 3px 15px rgba(0, 0, 0, 0.17);
    box-shadow: 0 3px 15px rgba(0, 0, 0, 0.17);
  }

  .d-flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .flex-column {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .flex-row {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
  }

  .justify-content-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .justify-content-between {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
  }

  .align-items-center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .align-content-center {
    -ms-flex-line-pack: center;
    align-content: center;
  }

  .flex-wrap {
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  p {
    font-size: 13px;
    line-height: 18px;
    margin: 0 0 16px;
  }

  .intro-text {
    margin-bottom: 11px;
  }

  .intro-text .bold {
    font-weight: 700;
  }

  .btn-link {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-weight: 300;
    width: 100%;
    max-width: 170px;
    height: 30px;
    background-color: #0087ff;
    font-size: 13px;
    color: #fff;
    padding-top: 0;
    text-decoration: none;
    border-radius: 3px;
  }

  .link-text {
    color: #1f96ff;
    text-decoration: none;
  }

  .sidebar {
    -webkit-box-flex: 0;
    -ms-flex: 0 1 393px;
    flex: 0 1 393px;
    max-width: 393px;
    height: 100vh;
    background-color: #505050;
    height: auto;
  }

  #logo {
    display: flex;
    align-items: center;
    justify-content: center;

    a {
      font-weight: 700;
      font-size: 44px;
      color: #fff;
      text-decoration: none;
      text-transform: uppercase;
      border: 2px solid #fff;
      padding: 0 10px 0 15px;

      &:hover {
        border-color: #0087ff;
      }
    }
  }

  .payment-content {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 calc(100% - 393px);
    flex: 1 0 calc(100% - 393px);
  }

  .payment-content > .container-payment-fail {
    width: 100%;
    max-width: 522px;
    padding: 150px 0;
  }

  .container-payment-fail {
    width: 100%;
  }
}
</style>
